export type { TracingDifficulty } from 'src/utils/tracingDifficulty';
export {
  getStoredTracingDifficulty,
  setStoredTracingDifficulty,
} from 'src/utils/tracingDifficulty';

export type TracingCharacterType = 'hanzi' | 'kana' | 'hangul';

export const isCJKUnifiedIdeograph = (char: string): boolean => {
  const code = char.codePointAt(0);
  if (!code) return false;
  return (
    (code >= 0x4e00 && code <= 0x9fff) ||
    (code >= 0x3400 && code <= 0x4dbf) ||
    (code >= 0x20000 && code <= 0x2a6df) ||
    (code >= 0x2a700 && code <= 0x2b73f) ||
    (code >= 0x2b740 && code <= 0x2b81f) ||
    (code >= 0xf900 && code <= 0xfaff)
  );
};

export const isHiragana = (char: string): boolean => {
  const code = char.codePointAt(0);
  if (!code) return false;
  return code >= 0x3040 && code <= 0x309f;
};

export const isKatakana = (char: string): boolean => {
  const code = char.codePointAt(0);
  if (!code) return false;
  return code >= 0x30a0 && code <= 0x30ff;
};

export const isHangul = (char: string): boolean => {
  const code = char.codePointAt(0);
  if (!code) return false;
  return (
    (code >= 0xac00 && code <= 0xd7af) ||
    (code >= 0x1100 && code <= 0x11ff) ||
    (code >= 0x3130 && code <= 0x318f)
  );
};

export const getTracingCharacterType = (char: string): TracingCharacterType | null => {
  if (isCJKUnifiedIdeograph(char)) return 'hanzi';
  if (isHiragana(char) || isKatakana(char)) return 'kana';
  if (isHangul(char)) return 'hangul';
  return null;
};

export const isTraceable = (text: string): boolean => {
  if ([...text].length !== 1) return false;
  return getTracingCharacterType(text) !== null;
};

export const STROKE_ACCURACY_THRESHOLD = 0.8;
export const MAX_ATTEMPTS = 2;
export const MEDIUM_OUTLINE_FADE_MS = 2500;
